module.exports = __webpack_public_path__ + "img/variable-1.8ea4e29e.png";